import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-last-updated-on',
  templateUrl: './last-updated-on.component.html'
})
export class LastUpdatedOnComponent implements OnInit {
  @Input() deviceId: any;
  @Input() requestType: any;
  lastUpdatedOn: string = ''

  constructor(private _Service: ApiService, private translate: TranslateService) { }

  ngOnChanges(): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (this.deviceId) {
      this.getLastUpdatedOn()
    }
  }

  ngOnInit(): void {
  }

  getLastUpdatedOn() {
    this._Service.getService(this._Service.API_URL.getLastUpdatedOn + this.deviceId + '/' + this.requestType).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.lastUpdatedOn = response.data;
      }
    })
  }

}
